import { render } from "./FilterYatirimlarSvg.vue?vue&type=template&id=08b2be9b"
import script from "./FilterYatirimlarSvg.vue?vue&type=script&lang=js"
export * from "./FilterYatirimlarSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__